export default "__VITE_ASSET__CahQ_$gg__"